export const HTTPS = process.env.REACT_APP_HTTPS;
export const HOST = process.env.REACT_APP_HOST;
export const PORT = process.env.REACT_APP_PORT;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const SERVICE = process.env.REACT_APP_SERVICE;
const DOCUMENT_HTTPS = process.env.REACT_APP_DOCUMENT_HTTPS;
const DOCUMENT_HOST = process.env.REACT_APP_DOCUMENT_HOST;
const DOCUMENT_PORT = process.env.REACT_APP_DOCUMENT_PORT;

export const BASE_URL = `${HTTPS}://${HOST}:${PORT}` + (SERVICE !== "" ? "/" + SERVICE : "");
export const VERSION = "/v1";
export const Upload_File_POST = `${DOCUMENT_HTTPS}://${DOCUMENT_HOST}:${DOCUMENT_PORT}/api/attachment/${CLIENT_ID}/upload`;
// export const Upload_File_POST = `${BASE_URL}/public/upload-file/inBase64`;
export const Download_File_GET = `${DOCUMENT_HTTPS}://${DOCUMENT_HOST}:${DOCUMENT_PORT}/api/attachment/${CLIENT_ID}/download/{attachemntId}`;


// File Upload API
export const BASE_URL_FILE_UPLOAD = BASE_URL + "/public/v1/upload-file/inBase64";
export const BASE_URL_MULTI_PART_FILE_UPLOAD = BASE_URL + "/public/v1/upload-file/inMultipartFile";


export const BASE_URL_V1 = BASE_URL + "/api/v1/";
export const BASE_URL_OPS_V1 = BASE_URL + "/ops/v1/";
export const BASE_URL_OPS_V1_Rest = BASE_URL + "/ops/v1/rest/";
export const BASE_URL_OPS_V1_Cusi = BASE_URL + "/ops/v1/cuisine/";
export const BASE_URL_OPS_V1_RestaurantEmployee = BASE_URL + "/ops/v1/restEmp/";
export const BASE_URL_OPS_V1_Item = BASE_URL + "/ops/v1/item/";
export const BASE_URL_OPS_V1_Ingredient = BASE_URL + "/ops/v1/ingredient/";
export const BASE_URL_OPS_V1_Admin = BASE_URL + "/ops/v1/user-admin/";
export const BASE_URL_OPS_V1_Brand = BASE_URL + "/ops/v1/brand/";
export const BASE_URL_OPS_V1_UOM = BASE_URL + "/ops/v1/uom/";

// Login
export const Admin_Login_POST = BASE_URL + "/auth/admin-login";
export const Client_Login_POST = BASE_URL + "/auth/client-login";
export const Agent_Login_POST = BASE_URL + "/auth/agent-login";

// OTP API's
export const Get_Otp_List_POST = BASE_URL_OPS_V1 + "one-time-password/otp-list"

//Resturent API's
export const GET_Resturent_List_POST = BASE_URL_OPS_V1_Rest + "restaurant-list";
export const GET_Resturent_Deleted_List_POST =
  BASE_URL_OPS_V1_Rest + "deleted-list";
export const Delete_Resturent_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_Rest + "delete/{uuid}";
export const Revive_Resturent_List_Item_PUT =
  BASE_URL_OPS_V1_Rest + "revive/{uuid}";
export const Get_Resturent_List_Item_GET = BASE_URL_OPS_V1_Rest + "get/{uuid}";
export const Activate_Resturent_List_Item_PUT =
  BASE_URL_OPS_V1_Rest + "activate/{uuid}";
export const Inactivate_Resturent_List_Item_PUT =
  BASE_URL_OPS_V1_Rest + "inactivate/{uuid}";
export const Save_Resturent_List_Item_POST = BASE_URL_OPS_V1_Rest + "save";
export const Edit_Resturent_List_Item_PUT =
  BASE_URL_OPS_V1_Rest + "update/{uuid}";
export const Get_Resturent_List_Item_Key_Value_GET =
  BASE_URL_OPS_V1_Rest + "key-value-list";

//Cuisine API's
export const GET_Cuisine_List_POST = BASE_URL_OPS_V1_Cusi + "list";
export const GET_Cuisine_Deleted_List_POST =
  BASE_URL_OPS_V1_Cusi + "deleted-list";
export const Delete_Cuisine_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_Cusi + "delete/{uuid}";
export const Revive_Cuisine_List_Item_PUT =
  BASE_URL_OPS_V1_Cusi + "revive/{uuid}";
export const Get_Cuisine_List_Item_GET = BASE_URL_OPS_V1_Cusi + "get/{uuid}";
export const Activate_Cuisine_List_Item_PUT =
  BASE_URL_OPS_V1_Cusi + "activate/{uuid}";
export const Inactivate_Cuisine_List_Item_PUT =
  BASE_URL_OPS_V1_Cusi + "inactivate/{uuid}";
export const Save_Cuisine_List_Item_POST = BASE_URL_OPS_V1_Cusi + "save";
export const Edit_Cuisine_List_Item_PUT =
  BASE_URL_OPS_V1_Cusi + "update/{uuid}";
export const Get_Cuisine_List_Item_Key_Value_GET =
  BASE_URL_OPS_V1_Cusi + "key-value-list";

//Item API's
export const GET_Item_List_POST = BASE_URL_OPS_V1_Item + "list/{cuisineId}/{recipeType}";
export const GET_Item_Deleted_List_POST = BASE_URL_OPS_V1_Item + "deleted-list/{cuisineId}/{recipeType}";
export const Delete_Item_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_Item + "delete/{uuid}";
export const Revive_Item_List_Item_PUT = BASE_URL_OPS_V1_Item + "revive/{uuid}";
export const Get_Item_List_Item_GET = BASE_URL_OPS_V1_Item + "get/{uuid}";
export const Activate_Item_List_Item_PUT =
  BASE_URL_OPS_V1_Item + "activate/{uuid}";
export const Inactivate_Item_List_Item_PUT =
  BASE_URL_OPS_V1_Item + "inactivate/{uuid}";
export const Save_Item_List_Item_POST = BASE_URL_OPS_V1_Item + "save";
export const Edit_Item_List_Item_PUT = BASE_URL_OPS_V1_Item + "update/{uuid}";
export const Get_Item_key_List_GET = BASE_URL_OPS_V1_Item + "key-value-list";
export const Get_Condiment_List_POST = BASE_URL_OPS_V1 + "condiment/list";
export const Get_Customization_List_POST = BASE_URL_OPS_V1 + "customization/list";

//Restaurant Employee API's
export const GET_RestaurantEmployee_List_POST =
  BASE_URL_OPS_V1_RestaurantEmployee + "list";
export const GET_RestaurantEmployee_Deleted_List_POST =
  BASE_URL_OPS_V1_RestaurantEmployee + "deleted-list";
export const Delete_RestaurantEmployee_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_RestaurantEmployee + "delete/{uuid}";
export const Revive_RestaurantEmployee_List_Item_PUT =
  BASE_URL_OPS_V1_RestaurantEmployee + "revive/{uuid}";
export const Get_RestaurantEmployee_List_Item_GET =
  BASE_URL_OPS_V1_RestaurantEmployee + "get/{uuid}";
export const Activate_RestaurantEmployee_List_Item_PUT =
  BASE_URL_OPS_V1_RestaurantEmployee + "activate/{uuid}";
export const Inactivate_RestaurantEmployee_List_Item_PUT =
  BASE_URL_OPS_V1_RestaurantEmployee + "inactivate/{uuid}";
export const Save_RestaurantEmployee_List_Item_POST =
  BASE_URL_OPS_V1_RestaurantEmployee + "save";
export const Edit_RestaurantEmployee_List_Item_PUT =
  BASE_URL_OPS_V1_RestaurantEmployee + "update/{uuid}";

// Ingredient API's
export const GET_Ingredient_List_POST = BASE_URL_OPS_V1_Ingredient + "list";
export const GET_Ingredient_Deleted_List_POST =
  BASE_URL_OPS_V1_Ingredient + "deleted-list";
export const Delete_Ingredient_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_Ingredient + "delete/{uuid}";
export const Revive_Ingredient_List_Item_PUT =
  BASE_URL_OPS_V1_Ingredient + "revive/{uuid}";
export const Get_Ingredient_List_Item_GET =
  BASE_URL_OPS_V1_Ingredient + "get/{uuid}";
export const Activate_Ingredient_List_Item_PUT =
  BASE_URL_OPS_V1_Ingredient + "activate/{uuid}";
export const Inactivate_Ingredient_List_Item_PUT =
  BASE_URL_OPS_V1_Ingredient + "inactivate/{uuid}";
export const Save_Ingredient_List_Item_POST =
  BASE_URL_OPS_V1_Ingredient + "save";
export const Edit_Ingredient_List_Item_PUT =
  BASE_URL_OPS_V1_Ingredient + "update/{uuid}";
export const Get_Ingredient_List_Item_Key_Value_GET =
  BASE_URL_OPS_V1_Ingredient + "key-value-list";
export const Get_Ingredient_Fetch_List_Item_GET =
  BASE_URL_OPS_V1_Ingredient + "fetch-ingredient";

// Brand API's
export const GET_Brand_List_POST = BASE_URL_OPS_V1_Brand + "list";
export const GET_Brand_Deleted_List_POST =
  BASE_URL_OPS_V1_Brand + "deleted-list";
export const Delete_Brand_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_Brand + "delete/{uuid}";
export const Revive_Brand_List_Item_PUT =
  BASE_URL_OPS_V1_Brand + "revive/{uuid}";
export const Get_Brand_List_Item_GET = BASE_URL_OPS_V1_Brand + "get/{uuid}";
export const Activate_Brand_List_Item_PUT =
  BASE_URL_OPS_V1_Brand + "activate/{uuid}";
export const Inactivate_Brand_List_Item_PUT =
  BASE_URL_OPS_V1_Brand + "inactivate/{uuid}";
export const Save_Brand_List_Item_POST = BASE_URL_OPS_V1_Brand + "save";
export const Edit_Brand_List_Item_PUT = BASE_URL_OPS_V1_Brand + "update/{uuid}";
export const Get_Brand_List_Item_Key_Value_GET =
  BASE_URL_OPS_V1_Brand + "key-value-list";

// Unit Of Measurement  API's
export const GET_UOM_List_POST = BASE_URL_OPS_V1_UOM + "list";
export const GET_UOM_Deleted_List_POST = BASE_URL_OPS_V1_UOM + "deleted-list";
export const Delete_UOM_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_UOM + "delete/{uuid}";
export const Revive_UOM_List_Item_PUT = BASE_URL_OPS_V1_UOM + "revive/{uuid}";
export const Get_UOM_List_Item_GET = BASE_URL_OPS_V1_UOM + "get/{uuid}";
export const Activate_UOM_List_Item_PUT =
  BASE_URL_OPS_V1_UOM + "activate/{uuid}";
export const Inactivate_UOM_List_Item_PUT =
  BASE_URL_OPS_V1_UOM + "inactivate/{uuid}";
export const Save_UOM_List_Item_POST = BASE_URL_OPS_V1_UOM + "save";
export const Edit_UOM_List_Item_PUT = BASE_URL_OPS_V1_UOM + "update/{uuid}";
export const Get_UOM_List_Item_Key_Value_GET =
  BASE_URL_OPS_V1_UOM + "key-value-list";
export const Get_UOM_Fetch_List_Item_GET = BASE_URL_OPS_V1_UOM + "fetch-uom";

//Restaurant Admin API's
export const GET_UserAdmin_List_POST = BASE_URL_OPS_V1_Admin + "list";
export const GET_UserAdmin_Deleted_List_POST =
  BASE_URL_OPS_V1_Admin + "deleted-list";
export const Delete_UserAdmin_Deleted_List_Item_DELETE =
  BASE_URL_OPS_V1_Admin + "delete/{uuid}";
export const Revive_UserAdmin_List_Item_PUT =
  BASE_URL_OPS_V1_Admin + "revive/{uuid}";
export const Get_UserAdmin_List_Item_GET = BASE_URL_OPS_V1_Admin + "get/{uuid}";
export const Activate_UserAdmin_List_Item_PUT =
  BASE_URL_OPS_V1_Admin + "activate/{uuid}";
export const Inactivate_UserAdmin_List_Item_PUT =
  BASE_URL_OPS_V1_Admin + "inactivate/{uuid}";
export const Save_UserAdmin_List_Item_POST = BASE_URL_OPS_V1_Admin + "save";
export const Edit_UserAdmin_List_Item_PUT =
  BASE_URL_OPS_V1_Admin + "update/{uuid}";
